import { render, staticRenderFns } from "./table-daily.vue?vue&type=template&id=3ca63fb2"
import script from "./table-daily.vue?vue&type=script&lang=js"
export * from "./table-daily.vue?vue&type=script&lang=js"
import style0 from "./table-daily.vue?vue&type=style&index=0&id=3ca63fb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports